export const ROLE_KEYCLOAK_MANAGER = 'keycloak-manager';

export const KEYCLOAK_MANAGER_ROLES = [ROLE_KEYCLOAK_MANAGER];
